import { isEqual } from 'lodash';

import { SearchBarState } from './types';

export function formatSearchQuery(state: SearchBarState, initialValues: SearchBarState) {
  return {
    recentlyActive: state.recentlyActive?.find((val) => val.selected)?.value,
    vettingStatus: state.vettingStatus?.find((val) => val.selected)?.value,
    experience: state.experience.filter((val) => val.selected).map(({ value }) => value),
    gender: state.gender.filter((val) => val.selected).map(({ value }) => value),
    search: state.search,
    //  only set if not initial values
    height: isEqual(state.height, initialValues.height)
      ? undefined
      : {
          min: state.height[0],
          max: state.height[1],
        },
    ageRange: isEqual(state.ageRange, initialValues.ageRange)
      ? undefined
      : {
          min: state.ageRange[0],
          max: state.ageRange[1],
        },
    tags: {
      industry: state.industry.filter((val) => val.selected).map(({ value }) => value),
      niche: state.niche.filter((val) => val.selected).map(({ value }) => value),
      'filming backdrop': state.filmingBackdrop.filter((val) => val.selected).map(({ value }) => value),
      model: state.model
        .filter((val) => val.selected && !['children', 'teenagers'].includes(val.value))
        .map(({ value }) => value),
      ethnicity: state.ethnicity.filter((val) => val.selected).map(({ value }) => value),
      age: state.ageTags.filter((val) => val.selected).map(({ value }) => value),
      language: state.language.filter((val) => val.selected).map(({ value }) => value),
    },
    models: {
      children: state.model.filter((val) => val.selected).some(({ value }) => value === 'children'),
      teenagers: state.model.filter((val) => val.selected).some(({ value }) => value === 'teenagers'),
    },
    countries: state.countries?.filter((val) => val.selected).map(({ value }) => value) ?? [],
    states: state.states?.filter((val) => val.selected).map(({ value }) => value) ?? [],
  };
}
